import React, { useEffect, useState } from "react";
import ClickaCookPoster from "../../Asset/Image/Joinus.png";
import './Advertisement.css';

const Advertisement = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className={`cc-advertisement ${isVisible ? "cc-ad-visible" : ""}`}>
      {/* Enhanced Background Elements */}
      <div className="cc-bg-blob cc-bg-blob-1" />
      <div className="cc-bg-blob cc-bg-blob-2" />
      
      {/* Floating Particles */}
      <div className="cc-floating-particles">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="cc-particle"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`
            }}
          />
        ))}
      </div>

      <div className="cc-container">
        <div className="cc-ad-content">
          {/* Text Content */}
          <div className="cc-text-content">
            {/* Enhanced Animated Badge */}
            <div className="cc-badge">
              <div className="cc-badge-shine" />
              <span className="cc-badge-icon">🚀</span>
              <span className="cc-badge-text">We're Hiring!</span>
            </div>

            {/* Enhanced Main Heading */}
            <h1 className="cc-main-heading">
              Become a
              <br />
              <span className="cc-home-cook-master">
                Home Cook
                <span className="cc-text-glow">
                  Home Cook
                </span>
              </span>
            </h1>
            
            {/* Enhanced Description */}
            <p className="cc-description">
              Join <strong className="cc-brand-name">ClickaCook</strong> and turn your passion for cooking into a rewarding career. 
              Cook for local families, set your own hours, and earn competitive income doing what you love.
            </p>

            {/* Enhanced Features Grid */}
            <div className="cc-features-grid">
              {[
                { icon: '💫', text: 'Flexible Schedule', desc: 'Work when you want', color: '#FFD700' },
                { icon: '💰', text: 'Great Pay', desc: 'Competitive earnings', color: '#FF6B35' },
                { icon: '👨‍👩‍👧‍👦', text: 'Local Families', desc: 'Serve your community', color: '#FFD700' },
                { icon: '🎯', text: 'Quick Setup', desc: 'Start in days', color: '#FF6B35' }
              ].map((feature, index) => (
                <div
                  key={index}
                  className="cc-feature-card"
                  style={{ '--feature-color': feature.color }}
                >
                  <div className="cc-feature-icon">
                    {feature.icon}
                  </div>
                  <div className="cc-feature-content">
                    <div className="cc-feature-title">{feature.text}</div>
                    <div className="cc-feature-desc">{feature.desc}</div>
                  </div>
                  <div className="cc-feature-glow" />
                </div>
              ))}
            </div>

            {/* Enhanced CTA Section */}
            <div className="cc-cta-section">
              <div className="cc-stats">
                <div className="cc-stats-content">
                  <div className="cc-stats-line" />
                  <span className="cc-stats-text">
                    <strong>50+</strong> chefs already joined
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Enhanced Image Content */}
          <div className="cc-image-content">
            <div className="cc-image-container">
              <img
                src={ClickaCookPoster}
                alt="Join ClickaCook Chef Team - Cook for Local Families"
                className="cc-poster-image"
              />
              
              {/* Enhanced Gradient Overlay */}
              <div className="cc-image-overlay" />
              
              {/* Shine Effect */}
              <div className="cc-image-shine" />
            </div>
            
            {/* Floating Achievement Badge */}
            <div className="cc-floating-badge">
              ⭐ Premium Chefs
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advertisement;